import { render } from "./setDiscountGold.vue?vue&type=template&id=00e4dcae&scoped=true"
import script from "./setDiscountGold.vue?vue&type=script&lang=js"
export * from "./setDiscountGold.vue?vue&type=script&lang=js"

import "./setDiscountGold.vue?vue&type=style&index=0&id=00e4dcae&lang=scss"
import "./setDiscountGold.vue?vue&type=style&index=1&id=00e4dcae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00e4dcae"]])

export default __exports__